import { render, staticRenderFns } from "./SkuRewardsTips.vue?vue&type=template&id=589805bd&scoped=true&"
import script from "./SkuRewardsTips.vue?vue&type=script&lang=js&"
export * from "./SkuRewardsTips.vue?vue&type=script&lang=js&"
import style0 from "./SkuRewardsTips.vue?vue&type=style&index=0&id=589805bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589805bd",
  null
  
)

export default component.exports